module.exports = require("@splunk/dashboard-visualizations/utils/propUtils");